import Landing from "../shared/utils/images/landing.webp";
import Stats from "../shared/utils/images/stats.webp";
import ITP from "../shared/utils/images/Logo ITP - Web - Secondary - Standard.png";
import Kuka from "../shared/utils/images/KUKA.png";
import Colt from "../shared/utils/images/Colt.png";
import ATPS from "../shared/utils/images/ATPS.png";
import ATF from "../shared/utils/images/Ateliere-Fără-Frontiere.png";
import { Footer } from "../components/Footer";
import { Helmet } from "react-helmet-async";
// import { CookiesAgree } from '../components/CookiesAgree';

export default function Home() {
  return (
    <>
      {/* <section className='CookiesAgree'>
        <CookiesAgree />
      </section>   */}
      <Helmet>
        <title>Drag de Bine - Fapte bune făcute cu drag</title>
        <meta
          name="description"
          content="Sprijin educațional, emoțional și material pentru copii și comunități din Sibiu. Implică-te: donează sau devino voluntar!"
        />
      </Helmet>

      <main>
        <div className="mx-auto mt-40 max-w-prose lg:max-w-7xl px-4 sm:px-0">
          <div className="text-left md:text-center">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl">
              <span className="block motto tracking-wide xl:inline">
                Fapte bune,
              </span>{" "}
              <span className="block motto tracking-wide text-pink xl:inline">
                făcute cu drag{" "}
              </span>
            </h1>
          </div>
        </div>

        <div className="mx-auto max-w-prose">
          <div className="rounded-md md:hidden px-4 sm:px-0 pt-2">
            <a
              href="/Donate"
              className="inline-flex shadow items-center justify-center rounded-md border border-transparent bg-purpleDDB-500 px-5 py-2 text-base font-medium text-white hover:bg-purpleDDB-600"
            >
              Donează
            </a>
          </div>
        </div>

        <section>
          <div className="overflow-hidden bg-white">
            <div className="relative mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:px-8">
              <div className="absolute top-0 bottom-0 mt-16 left-3/4 hidden w-screen bg-gray-50 lg:block"></div>
              <div className="mx-auto max-w-prose text-base lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-8">
                <div>
                  <h2 className="text-3xl font-bold tracking-tight text-pink">
                    Ce facem noi?
                  </h2>
                </div>
              </div>
              <div className="mt-2 lg:grid lg:grid-cols-2 lg:gap-8">
                <div className="relative lg:col-start-2 lg:row-start-1 mt-16">
                  <svg
                    className="absolute top-0 right-0 -mt-20 -mr-20 hidden lg:block"
                    width="404"
                    height="384"
                    fill="none"
                    viewBox="0 0 404 384"
                    aria-hidden="true"
                  >
                    <defs>
                      <pattern
                        id="de316486-4a29-4312-bdfc-fbce2132a2c1"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                        patternUnits="userSpaceOnUse"
                      >
                        <rect
                          x="0"
                          y="0"
                          width="4"
                          height="4"
                          className="text-gray-200"
                          fill="currentColor"
                        ></rect>
                      </pattern>
                    </defs>
                    <rect
                      width="404"
                      height="384"
                      fill="url(#de316486-4a29-4312-bdfc-fbce2132a2c1)"
                    ></rect>
                  </svg>
                  <div className="relative mx-auto max-w-prose text-base lg:max-w-none mt-0 lg:mt-6">
                    <figure>
                      <div className="aspect-w-12 aspect-h-7 lg:aspect-none">
                        <img
                          className="rounded-lg object-cover object-center shadow-lg"
                          src={Landing}
                          alt="Excursie la Filarmonica Sibiu"
                          width="1184"
                          height="1376"
                        />
                      </div>
                    </figure>
                  </div>
                </div>
                <div className="mt-8 lg:mt-0">
                  <div className="mx-auto max-w-prose text-base leading-7 lg:max-w-none text-justify">
                    <p>
                      <b>Nu ne plac poveștile triste. Dar ele există. </b>Și
                      când întâlnești copii care trăiesc povești complicate,
                      vrei să faci ceva cu sens pentru ei.
                    </p>
                    <br />
                    <p>
                      Lucrăm cu copii care duc griji mai grele decât ar trebui
                      pentru vârstele lor. Copii care sar peste copilăria lor.
                      Copii care au nevoie de sprijin real mai ales pentru a
                      învăța că ei contează.
                    </p>
                    <br />

                    <h3 className="font-bold text-lg md:text-xl lg:text-[20px] leading-tight mb-2">
                      🎒 Oferim sprijin educațional
                    </h3>
                    <ul className="checked-to-do">
                      <li>
                        &#10003; Susținem after-schooluri sociale pentru elevi
                        ai claselor 0-8 din două comunități din apropierea
                        Sibiului, cu ore de educație remedială adaptate nevoilor
                        fiecărui copil.
                      </li>
                      <li>
                        &#10003; Sprijinim online individualizat și constant
                        copiii care nu au alternativa de a participa fizic.
                      </li>
                    </ul>
                    <br />
                    <h3 className="font-bold text-lg md:text-xl lg:text-[20px] leading-tight mb-2">
                      🧠 Susținem dezvoltarea emoțională
                    </h3>
                    <ul className="checked-to-do">
                      <li>
                        &#10003; Organizăm tabere și excursii care le arată
                        copiilor că lumea e mai mare decât satul lor. Acestea îi
                        ajută să se simtă în siguranță și să aloce energie spre
                        a își valorifica potențialul.
                      </li>
                      <li>
                        &#10003; Oferim acces la grupuri de sprijin, jocuri,
                        discuții, timp de calitate.
                      </li>
                      <li>
                        &#10003; Organizăm ateliere și activități prin care
                        copiii își descoperă puterea și curajul.
                      </li>
                    </ul>
                    <br />
                    <h3 className="font-bold text-lg md:text-xl lg:text-[20px] leading-tight mb-2">
                      👩‍🏫 Oferim susținere pentru îndrumătorii copiilor
                    </h3>
                    <ul className="checked-to-do">
                      <li>
                        &#10003; Oferim acces la traininguri pentru profesorii
                        care lucrează cu copii vulnerabili.
                      </li>
                      <li>
                        &#10003; Donăm materiale educaționale, rechizite, cărți
                        și jocuri pentru comunitățile defavorizate.
                      </li>
                    </ul>
                    <br />
                    <h3>🩺 Avem grijă de sănătatea lor</h3>
                    <ul className="checked-to-do">
                      <li>
                        &#10003; Am observat că chiar și un simplu control
                        medical e un pas important pentru mulți dintre ei.
                      </li>
                      <li>
                        &#10003; Problemele oftalmologice și cele dentare severe
                        sunt cele mai des întâlnite în rândul copiilor cu care
                        lucrăm. Fără un sprijin din partea noastră, șansele să
                        se rezolve aceste probleme ar fi fost foarte scăzute.
                      </li>
                    </ul>
                    <br />
                    <br />
                    <h2 className="text-3xl font-bold tracking-tight text-pink">
                      🌱 Ce schimbăm?
                    </h2>
                    <ul className="checked-to-do">
                      <li>
                        &#10003; Copiii încep să citească, să înțeleagă, să
                        întrebe fără teamă, să creadă că pot.
                      </li>
                      <li>
                        &#10003; Copiii descoperă locuri, oameni și perspective
                        care le erau inaccesibile.
                      </li>
                      <li>
                        &#10003; Copiii participă la activități cu inima
                        deschisă și întreabă: „Mai vii și mâine?”.
                      </li>
                      <li>
                        &#10003; Profesorii sunt mai lipsiți de griji, iar
                        astfel pot fi aproape de elevii lor.
                      </li>
                      <li>
                        &#10003; Voluntarii noștri devin oameni-sprijin pentru
                        acești copii.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="relative bg-gray-900">
            <div className="absolute bottom-0 h-80 w-full xl:inset-0 xl:h-full">
              <div className="h-full w-full xl:grid xl:grid-cols-2">
                <div className="h-full xl:relative xl:col-start-2">
                  <img
                    className="h-full w-full object-cover opacity-25 xl:absolute xl:inset-0"
                    src={Stats}
                    alt="Copii la excursie la Filarmonica din Sibiu"
                  />
                  <div
                    aria-hidden="true"
                    className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r"
                  ></div>
                </div>
              </div>
            </div>
            <div className="mx-auto max-w-prose px-4 sm:px-4 md:px-0 lg:max-w-7xl lg:px-8 xl:grid xl:grid-flow-col-dense xl:grid-cols-2 xl:gap-x-8">
              <div className="relative pt-12 pb-72 sm:pt-24 sm:pb-64 xl:col-start-1 xl:pb-24">
                <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
                  <span className="block">Vrei să ajuți?</span>
                  <span className="block text-pink">
                    Donează sau înscrie-te ca voluntar.
                  </span>
                </h2>

                <div className="mt-8 flex lg:mt-4 lg:flex-shrink-0 lg:gap-8">
                  <div className="inline-flex rounded-md shadow">
                    <a
                      href="https://dragdebine.ro/Donate"
                      className="inline-flex items-center justify-center rounded-md border border-transparent bg-purpleDDB-500 px-5 py-3 text-base font-medium text-white hover:bg-purpleDDB-600"
                    >
                      Donează
                    </a>
                  </div>
                  <div className="ml-3 inline-flex rounded-md shadow">
                    <a
                      href="https://dragdebine.ro/Volunteer"
                      className="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-purpleDDB-500 hover:bg-gray-50"
                    >
                      Voluntariat
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="bg-gray-100">
            <div className="mx-auto max-w-prose lg:max-w-7xl py-16 px-4 md:px-0 sm:py-20 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold tracking-tight text-pink">
                Cine ne sprijină?
              </h2>

              <div className="mt-8 lg:mt-10 grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 xs:grid-cols-2 gap-4">
                <div className="mt-8 sm:mt-8 md:mt-4">
                  <img
                    className="h-10 mx-auto"
                    src={ITP}
                    alt="IT Perspectives logo"
                  />
                  <p className="text-base font-normal text-gray-400 mt-3 text-center">
                    Powered by
                  </p>
                </div>
                <div className="mt-8 sm:mt-8 md:mt-4">
                  <img
                    className="h-8 mt-2 mx-auto"
                    src={Kuka}
                    alt="KUKA logo"
                  />
                  <p className="text-base font-normal text-gray-400 mt-3 text-center">
                    Sponsor
                  </p>
                </div>
                <div className="mt-8 sm:mt-8 md:mt-4">
                  <img
                    className="h-10 sm:h-10 md:h-12 lg:h-10 mx-auto"
                    src={Colt}
                    alt="Colt logo"
                  />
                  <p className="text-base font-normal text-gray-400 mt-3 text-center">
                    Sponsor
                  </p>
                </div>
                <div className="mt-8 sm:mt-8 md:mt-4">
                  <img
                    className="h-12 sm:h-12 md:h-12 lg:h-20 mx-auto"
                    src={ATPS}
                    alt="Mirage logo"
                  />
                  <p className="text-base font-normal text-gray-400 mt-3 text-center">
                    Partener
                  </p>
                </div>
                <div className="mt-8 sm:mt-8 md:mt-4">
                  <img
                    className="h-20 mx-auto"
                    src={ATF}
                    alt="Ateliere Fără Frontiere"
                  />
                  <p className="text-base font-normal text-gray-400 mt-3 text-center">
                    Donator
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
